import { Helmet } from "react-helmet-async";
import PropTypes from 'prop-types';

const AuthWrapper = ({ title, children }) => {
  let a;
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </>
  );
};

export default AuthWrapper;
AuthWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};